import { HTTP_PLANT_FETCHING, HTTP_PLANT_SUCCESS, HTTP_PLANT_FAILED } from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_PLANT_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_PLANT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_PLANT_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
